import { inject } from '@angular/core';
import { CanActivateFn, UrlTree } from '@angular/router';
import { ErrorInputs, ErrorService } from '@shared/services/error.service';

export const MaintenanceInProgressGuard: CanActivateFn = async (): Promise<boolean | UrlTree> => {
  const errorService: ErrorService = inject(ErrorService);

  const errorMaintenanceInProgress: ErrorInputs | null = await errorService.getErrorIfMaintenanceIsInProgress();
  if (errorMaintenanceInProgress) {
    errorService.showError(errorMaintenanceInProgress);
  }
  return true;
};
